import React from 'react';

import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

import './ContentSuggestionActions.scss';

const propTypes = {
  onApprove: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  approved: PropTypes.bool.isRequired,
  rejected: PropTypes.bool.isRequired,
};

function ContentSuggestionActions({ onApprove, onReject, approved, rejected }) {
  return (
    <Button.Group className="content-suggestion-actions" fluid>
      <Button
        basic={!rejected}
        negative
        className="reject-button"
        onClick={onReject}
        title="Reject suggestion"
      >
        Reject
      </Button>
      <Button
        basic={!approved}
        positive
        className="apply-button"
        onClick={onApprove}
        title="Apply suggestion"
      >
        Approve
      </Button>
    </Button.Group>
  );
}

ContentSuggestionActions.propTypes = propTypes;

export default ContentSuggestionActions;
